import { AbstractFormatObjectAlert } from "./AbstractFormatObjectAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export class ObjectAlert extends AbstractFormatObjectAlert {
  constructor(object: IFormatObjectEditable, description: string) {
    super(object, true);
    this._description = description;
  }

  protected readonly _description: string;

  get description(): string {
    return this._description;
  }

  get kind(): string {
    return this._detectedObject.getTypeName() + "警告";
  }
}
